export const paginationMixin = (page_size = 48) => ({
    count: 0,
    page: 1,
    page_size,
})
